// :cow: Cosmose CONFIDENTIAL :iso:
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CampaignSegmentType } from '@med/app/core/model/campaign-segment-type';
import { ConfigService } from '@med/app/core/config/config.service';
import { AdFormat } from '@med/app/shared/modules/ad-format/model/ad-format.model';


@Injectable()
export class AdFormatService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getAdFormats(campaignId: number, platformIds: number[]): Observable<AdFormat[]> {
    const url = `${ this.configService.getConfig().enterpriseApi }/campaigns/${ campaignId }/ad-formats`;
    const params = new HttpParams({fromObject: {platform_id: platformIds.toString()}});
    return this.http
      .get<AdFormat[]>(url, {params})
      .pipe(
        catchError((error: Response) => throwError(error || 'Server error')),
      );
  }

  getAdFormatsByStage(
    campaignId: number,
    stage: CampaignSegmentType,
    platformIds: number[],
  ): Observable<AdFormat[]> {
    const url = `${ this.configService.getConfig().enterpriseApi }/campaigns/${ campaignId }/stages/${ stage }/ad-formats`;
    const params = new HttpParams({fromObject: {platform_id: platformIds.toString()}});
    return this.http
      .get<AdFormat[]>(url, {params})
      .pipe(
        catchError((error: Response) => throwError(error || 'Server error')),
      );
  }
}
